<style scoped>
.application-tabs >>> .tab-content {
  border-left: 1px solid #26374a !important;
}

.application-tabs >>> .nav-link {
  border: none !important;
  border-bottom: none !important;
}

.application-tabs >>> .nav-tabs {
  border: none !important;
  border-bottom: none !important;
}

.application-tabs >>> li a.nav-link.active {
  color: #0a77bf !important;
  font-weight: bold;
  border: none;
}

.application-tabs >>> li a.nav-link {
  color: #26374a;
}
</style>
<template>
  <b-tabs :vertical="this.verticalTabs" class="application-tabs" v-model="tabIndex">
    <b-tab
      title="Introduction"
      id="tab-agreement"
      :title-link-class="agreementRequiredClass"
    >
      <b-card-body>
        <agreement-content
          ref="agreementContent"
          @tab-info-updated="tabUpdated"
          @move-to-next-tab="updateIndex"
        />
      </b-card-body>
    </b-tab>
    <b-tab
      title="Personal Information"
      id="tab-contact"
      :title-link-class="contactRequiredClass"
    >
      <b-card-body>
        <contact-content
          ref="contactContent"
          @tab-info-updated="tabUpdated"
          @move-to-next-tab="updateIndex"
        />
      </b-card-body>
    </b-tab>
    <b-tab :title-link-class="employmentRequiredClass">
      <template slot="title" id="profile-tab-employment">
        <badge :yOffset="10" :xOffset="-20">
          Employment Information
        </badge>
      </template>
      <b-card-body>
        <employment-content
          ref="employmentContent"
          @tab-info-updated="tabUpdated"
          @move-to-next-tab="updateIndex"
        />
      </b-card-body>
    </b-tab>
    <b-tab>
      <template slot="title" id="profile-tab-financial">
        <div class="title-container">
          <badge :yOffset="10" :xOffset="-20">
            Financial
          </badge>
        </div>
      </template>
      <b-card-body>
        <financial-content
          @tab-info-updated="tabUpdated"
          @move-to-next-tab="updateIndex"
        />
      </b-card-body>
    </b-tab>
    <b-tab
      title="Background Information"
      id="profile-tab-declarations"
      :title-link-class="declarationsRequiredClass"
    >
      <b-card-body>
        <declarations-content
          ref="declarationsContent"
          @tab-info-updated="tabUpdated"
          @move-to-next-tab="updateIndex"
        />
      </b-card-body>
    </b-tab>
    <b-tab
      title="Demographics"
      id="profile-tab-demographics"
      :title-link-class="demographicsRequiredClass"
    >
      <b-card-body>
        <demographics-content
          ref="demographicsContent"
          @tab-info-updated="tabUpdated"
          @move-to-next-tab="updateIndex"
        />
      </b-card-body>
    </b-tab>
    <b-tab
      title="Real Estate"
      id="profile-tab-real-estate-experience"
      :title-link-class="realEstateExperienceRequiredClass"
    >
      <b-card-body>
        <real-estate-content
          ref="realEstateExperienceContent"
          @tab-info-updated="tabUpdated"
          @move-to-next-tab="updateIndex"
        />
      </b-card-body>
    </b-tab>
    <b-tab title="Review & Submit Application" id="profile-tab-entity">
      <b-card-body>
        <application-content />
      </b-card-body>
    </b-tab>
  </b-tabs>
</template>

<script>
import Badge from '@/components/utils/Badge';
import ContactContent from '@/components/profile/sections/tabs/contact/ContactContent';
import FinancialContent from '@/components/profile/sections/tabs/financial/FinancialContent';
import DeclarationsContent from '@/components/profile/sections/tabs/declarations/DeclarationsContent';
import EmploymentContent from '@/components/profile/sections/tabs/employment/EmploymentContent';
import DemographicsContent from '@/components/profile/sections/tabs/demographics/DemographicsContent';
import RealEstateContent from '@/components/profile/sections/tabs/real_estate/RealEstateContent';
import ApplicationContent from '@/components/profile/sections/tabs/application/ApplicationContent';
import AgreementContent from '@/components/profile/sections/tabs/agreement/AgreementContent';
import { DECLARATIONS_TAB } from '@/components/profile/sections/tabs/tabNumbers';

export default {
  components: {
    AgreementContent,
    Badge,
    ContactContent,
    FinancialContent,
    EmploymentContent,
    DeclarationsContent,
    DemographicsContent,
    RealEstateContent,
    ApplicationContent,
  },
  props: {
    index: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      tabIndex: 0,
      agreementRequiredClass: '',
      contactRequiredClass: '',
      declarationsRequiredClass: '',
      demographicsRequiredClass: '',
      realEstateExperienceRequiredClass: '',
      employmentRequiredClass: '',
      verticalTabs: false,
      DECLARATIONS_TAB,
    };
  },
  watch: {
    index(val) {
      this.tabIndex = val;
    },
  },
  mounted() {
    this.$nextTick(() => this.requiredClass());
    window.onresize = () => {
      this.verticalTabs = window.innerWidth >= 1300;
    };
  },
  created() {
    this.verticalTabs = window.innerWidth >= 1300;
  },
  methods: {
    updateIndex(value) {
      this.tabIndex = value;
    },
    tabUpdated(identifier) {
      this.$notify({
        group: 'alert',
        text: `${identifier} updated.`,
      });
      window.scrollTo(0, 0);
      this.requiredClass();
    },
    requiredClass() {
      const contents = [
        'agreement',
        'contact',
        'employment',
        'declarations',
        'demographics',
        'realEstateExperience',
      ];
      Object.keys(contents).forEach((key) => {
        const content = contents[key];
        if (this.$refs[`${content}Content`].isValid()) {
          this[`${content}RequiredClass`] = '';
        } else {
          this[`${content}RequiredClass`] = 'errors';
          this.$refs[`${content}Content`].clearValidationErrors();
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/profile/sections/tabs/ProfileTabs.vue